export default __webpack_public_path__ + "add-new-app-icon@2x.png";